import RequestStatus from 'types/general/requests/RequestStatus';
import { createSlice } from '@reduxjs/toolkit';
import { GenericDataState, createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer, createResetRequestStatusReducer } from '../generic/GenericDataReducers';
import { IInvoice } from 'types/backend_models/invoices/IInvoice';

/* GENERIC */
const initialState: GenericDataState<IInvoice | null> = {
	requestStatus: RequestStatus.idle,
	data: null,
	error: null
};

/* SLICE */
const slice = createSlice({
	name: "invoice_detail",
	initialState: initialState,
	reducers: {
		setFetchInvoicePending: createSetFetchDataPendingReducer(),
		setFetchInvoiceSucces: createSetFetchDataSuccesReducer(),
		setFetchInvoiceError: createSetFetchDataErrorReducer(),
		resetFetchInvoiceStatus: createResetRequestStatusReducer()
	}
});

export const {
	setFetchInvoicePending,
	setFetchInvoiceSucces,
	setFetchInvoiceError,
	resetFetchInvoiceStatus
} = slice.actions;

export default slice.reducer;